import React from 'react';
import { Gradient } from '../Gradient';

const Adjust = ({ type, className = '', color = '#737373' }) => {
  return (

<svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
<path d="M9.3342 3.08356L1.41671 3.08355M9.3342 3.08356C9.3342 4.23428 10.267 5.1671 11.4177 5.1671C12.5685 5.1671 13.5013 4.23426 13.5013 3.08355C13.5013 1.93284 12.5685 1 11.4177 1C10.267 1 9.3342 1.93285 9.3342 3.08356ZM13.0846 8.08406H5.1671M5.1671 8.08406C5.1671 9.23477 4.23426 10.1676 3.08355 10.1676C1.93284 10.1676 1 9.23478 1 8.08407C1 6.93336 1.93284 6.00052 3.08355 6.00052C4.23426 6.00052 5.1671 6.93334 5.1671 8.08406ZM9.3342 13.0846L1.41671 13.0846M9.3342 13.0846C9.3342 14.2353 10.267 15.1681 11.4177 15.1681C12.5685 15.1681 13.5013 14.2353 13.5013 13.0846C13.5013 11.9339 12.5685 11.001 11.4177 11.001C10.267 11.001 9.3342 11.9339 9.3342 13.0846Z" 
stroke={type === 'plain' ? color : 'url(#globalGradient)'} 
      strokeWidth="1" 
      strokeLinecap="round"/>
      <Gradient className={className} />
</svg>

  );
};

export default Adjust;